<template>
  <div class="todos">
    <home-header></home-header>
    <personal-center></personal-center>
    <div class="content page-width" style="padding: 0px">
      <div class="content-right pull-left" style="margin-top: 0px">
        <div class="todo-title">
          <strong style="font-weight: bold; font-size: 18px">待办事项</strong>
          <span style="color: red; margin-left: 16px">{{ todoTitle }}</span>
        </div>
        <div class="todo-list">
          <a-tabs v-model="activeKey" @change="callback">
            <a-tab-pane :key="0" tab="未完成"> </a-tab-pane>
            <a-tab-pane :key="1" tab="已完成"> </a-tab-pane>
          </a-tabs>
          <div class="todo-item" v-for="(item, index) in todos" :key="item.id">
            <div class="index">
              <template v-if="index < 9">0</template>{{ index + 1 }}
            </div>
            <div class="info">
              <div class="title">
                <h3>{{ item.title }}</h3>
                <p :class="item.isMustDealLogin === 1 ? 'danger' : 'warning'">
                  {{ item.isMustDealLogin === 1 ? "必办项" : "待办项" }}
                </p>
                <span :class="item.isAnswer ? 'done' : 'undone'">{{
                  item.isAudit == 1
                    ? item.reviewStatus == 1
                      ? "待审核"
                      : item.reviewStatus == 4
                      ? "已驳回"
                      : item.reviewStatus == 2
                      ? "已完成"
                      : "未完成"
                    : item.isAnswer
                    ? "已完成"
                    : item.reviewRemark
                    ? "已驳回"
                    : "未完成"
                }}</span>
              </div>
              <div class="time" v-if="item.endTime">
                <img src="../../assets/images/endTimeIcon.png" alt="" />
                <span>截止日期：{{ item.endTime.substr(0, 16) }}</span>
              </div>
            </div>
            <div class="btns">
              <a-button type="primary" shape="round" class="btn sub" @click="goDetail(item)">
                {{ item.isAnswer ? "查看已完成" : item.reviewRemark ? "查看驳回原因" : "去完成" }}
              </a-button>
            </div>
          </div>
          <div style="text-align: center; width: 100%; padding: 20px" v-if="todos.length === 0">
            暂无数据
          </div>
          <div class="desc">说明：{{ todoDesc }}</div>
          <div class="goHome">
            <a-button type="primary" class="home" @click="backHome">返回首页</a-button>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import PersonalCenter from '@/common/components/PersonalCenter'
import { mapState } from 'vuex'
export default {
  name: 'todos-list',
  components: {
    HomeHeader,
    Foot,
    PersonalCenter
  },
  data() {
    return {
      activeKey: 0
    }
  },
  created() {
    this.callback()
  },
  computed: {
    ...mapState(['todos', 'todoTitle', 'todoDesc'])
  },
  methods: {
    backHome() {
      this.$router.push('/')
    },
    goDetail({ id, isAnswer, targetUrl, groupName, content, fmKey, studentId }) {
      if (targetUrl) {
        if (targetUrl.indexOf('?') > 0) {
          this.$router.push(targetUrl + `&bid=${id}&pt=todo`)
        } else {
          this.$router.push(targetUrl + `?bid=${id}&pt=todo`)
        }
      } else {
        this.$router.push(`/todos/detail?id=${id}&isAnswer=${isAnswer}&groupName=${groupName}&content=${content}&fmKey=${fmKey}&studentId=${studentId}`)
      }
    },
    callback() {
      this.$store.dispatch('getTodos', this.activeKey)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;
    width:100%;
    overflow: hidden;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}

.content {
  padding: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.detail {
  margin-bottom: 20px;
}
.todo-list{
    margin-top: 16px;
    background-color: #fff;
    padding: 16px;
    .todo-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F7F9F8;
        margin-bottom: 16px;
        padding: 8px 16px;
        height: 80px;
        .index{
            color: #2CAF7A;
            font-size: 26px;
            width: 120px;
            text-align: center;
            border-right: 1px dashed #aaa;
            height: 100%;
            line-height: 64px;
        }
        .info{
            flex: 1;
            padding-left: 16px;
            .title{
                display: flex;
                align-items: center;
                h3{
                    font-weight: bold;
                    font-size: 18px;
                }
                p,span{
                    font-size: 12px;
                    margin-left: 8px;
                    padding: 4px 8px;
                }
                .danger{
                    color: #fff;
                    background-color: #F16262;
                }
                .warning{
                    color: #fff;
                    background-color: #F6AD3B;
                }
                .done{
                    background: #D1EEDF;
                    color: #2CAF7A;
                }
                .undone{
                    background: #F7D9D9;
                    color: #FF3434;
                }
            }
            .time{
                margin-top: 8px;
                display: flex;
                align-items: center;
                span{
                    margin-left: 8px;
                    font-size: 14px;
                }
            }
        }
        .btns{
            width: 120px;
            .sub{
                width: 100%;
                background: $bgColor;
                color: #fff;
                border: none;
            }
        }
    }
    .desc{
        padding: 16px 0;
        border-top: 1px dashed #aaa;
        font-size: 14px;
    }
    .goHome{
        text-align: center;
        .home{
            background: $bgColor;
            color: #fff;
            border: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/todos/index.vue